module.exports = __webpack_public_path__ + "static/media/portfolio1 (29).bf2761db.jpeg";